import React, { useState } from "react";
import { Box, Stack, Tab, Tabs, Typography, Chip } from "@mui/material";

import image100 from "../../assets/blog/image 100.png";
import image101 from "../../assets/blog/image 101.png";
import image102 from "../../assets/blog/image 102.png";
import poster1 from "../../assets/blog/image 103.png";
import poster2 from "../../assets/blog/image 104.png";
import poster3 from "../../assets/blog/image 105.png";

export default function BlogComponent() {
  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = (event, newValue) => setActiveTab(newValue);

  const videoData = [
    {
      image: image100,
      title: "Merchant Feature Demonstration",
      date: "August 20, 2022",
      link: "https://www.youtube.com/watch?v=AT4lAoASvKk",
    },
    {
      image: image101,
      title: "MoiPay Digital Wallet Demonstration",
      date: "August 20, 2022",
      link: "https://www.youtube.com/watch?v=XhDSdYdE4P0&pp=ygUGbW9pcGF5",
    },
    {
      image: image102,
      title: "MoiPay Split Feature Demonstration",
      date: "August 20, 2022",
      link: "https://www.youtube.com/watch?v=TiA6uAjSo0U&pp=ygUGbW9pcGF5",
    },
  ];

  const posterData = [{ image: poster1 }, { image: poster2 }, { image: poster3 }];

  return (
    <Box sx={{ bgcolor: "black", width: "100%", overflow: "hidden" }}>
      {/* Hero Section */}
      <Box
        sx={{
          width: "100%",
          position: "relative",
          background:
            "radial-gradient(50% 50% at 50% -20%, rgba(94,176,239,0.5) 0%, rgba(255,255,255,0) 100%)",
        }}
      >

        <Box
                  sx={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    top: "-20%",
                    left: 0,
                    background:
                      "radial-gradient(50% 50% at 50% 0%, rgba(94,176,239,0.5) 0%, rgba(255,255,255,0) 100%)",
                    zIndex: 0,
                  }}
                />
        <Stack
          alignItems="center"
          spacing={{ xs: 2, md: 4 }}
          sx={{ pt: { xs: 8, md: 12 }, pb: { xs: 4, md: 6 }, px: { xs: 2, sm: 4 } }}
        >
          <Typography
            sx={{
              background:
                "linear-gradient(176deg, rgba(255,255,255,1) 0%, rgba(113,113,122,1) 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontWeight: 700,
              fontSize: { xs: "28px", sm: "40px", md: "64px" },
              letterSpacing: "2px",
              lineHeight: { xs: "38px", sm: "48px", md: "80px" },
              textAlign: "center",
            }}
          >
            Blogs
          </Typography>

          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            centered
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            sx={{
              "& .MuiTabs-indicator": { backgroundColor: "white", height: "1px" },
              "& .MuiTab-root": {
                minWidth: "unset",
                textTransform: "none",
                mx: { xs: 1.5, md: 3 },
                fontWeight: 500,
                fontSize: { xs: "16px", sm: "20px", md: "28px" },
                color: "#a1a1aa",
              },
              "& .Mui-selected": {
                color: "white",
              },
            }}
          >
            <Tab label="Videos" />
            <Tab label="Posters" />
          </Tabs>
        </Stack>
      </Box>

      {/* Video Section */}
      {activeTab === 0 && (
        <Stack
          direction="row"
          sx={{
            flexWrap: "wrap",
            justifyContent: "center",
            gap: { xs: 2, sm: 3, md: 4 },
            px: { xs: 2, sm: 4, md: 8 },
            py: { xs: 4, md: 6 },
          }}
        >
          {videoData.map((video, index) => (
            <PostCard
              key={index}
              image={video.image}
              title={video.title}
              date={video.date}
              link={video.link}
              clickable
              showDetails
            />
          ))}
        </Stack>
      )}

      {/* Poster Section */}
      {activeTab === 1 && (
        <Stack
          direction="row"
          sx={{
            flexWrap: "wrap",
            justifyContent: "center",
            gap: { xs: 2, sm: 3, md: 4 },
            px: { xs: 2, sm: 4, md: 8 },
            py: { xs: 4, md: 6 },
          }}
        >
          {posterData.map((poster, index) => (
            <PostCard key={index} image={poster.image} posterCard />
          ))}
        </Stack>
      )}
    </Box>
  );
}

// Reusable Card Component
const PostCard = ({
  image,
  title,
  date,
  link,
  clickable = false,
  showDetails = false,
  posterCard = false,
}) => (
  <Box
    onClick={() => clickable && window.open(link, "_blank")}
    sx={{
      width: { xs: "100%", sm: "270px", md: "300px" },
      maxWidth: "320px",
      bgcolor: "rgba(255, 255, 255, 0.08)",
      borderRadius: 3,
      overflow: "hidden",
      border: "1px solid #242535",
      cursor: clickable ? "pointer" : "default",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
      "&:hover": clickable
        ? { transform: "translateY(-5px)", boxShadow: "0 0 15px rgba(94,176,239,0.4)" }
        : {},
    }}
  >
    <Box
      component="img"
      src={image}
      alt={title || "poster"}
      sx={{
        width: "100%",
        height: { xs: 180, sm: 220, md: 260 },
        objectFit: "cover",
        display: "block",
      }}
    />

    {showDetails && (
      <Stack spacing={1.5} sx={{ p: { xs: 1.5, sm: 2 } }}>
        <Chip
          label="Technology"
          sx={{
            bgcolor: "rgba(75,107,251,0.08)",
            color: "#4B6BFB",
            fontWeight: 500,
            fontSize: { xs: "12px", sm: "14px" },
            height: "auto",
            py: 0.3,
            px: 1,
            alignSelf: "flex-start",
          }}
        />
        <Typography
          variant="h6"
          sx={{
            color: "white",
            fontWeight: 600,
            fontSize: { xs: "16px", sm: "18px", md: "20px" },
            lineHeight: 1.4,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "#97989F",
            fontSize: { xs: "13px", sm: "14px", md: "15px" },
            fontWeight: 400,
          }}
        >
          {date}
        </Typography>
      </Stack>
    )}
  </Box>
);
